import { Providers } from './components/Providers';
import routes from './routes';

function App() {
  return (
    <Providers>
      {routes}
    </Providers>
  );
}

export default App;
